const formatTimestamp = (timestamp) => {
  if (!timestamp) {
    return "";
  }
  const date = new Date(timestamp);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  return date.toLocaleString("en-US", options).replace(",", "");
};

const PRODUCT_NAMES = {
  unstract: "unstract",
  llmWhisperer: "llm-whisperer",
  verticals: "verticals",
};

const SELECTED_PRODUCT = "selectedProduct";

export { formatTimestamp, PRODUCT_NAMES, SELECTED_PRODUCT };
